module.exports = __webpack_public_path__ + "img/ventilation.66c96619.svg";